<template>
  <div class="myorder">
    <el-card class="box-card" type="card">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- 搜索框 -->
        <div class="flex justify_content_between mtb520">
          <div>
            <el-input
              size="small"
              placeholder="输入订单编号"
              v-model="orderCode"
              clearable
            ></el-input>
            <el-select
              v-if="activeName == 'second'"
              class="ml20"
              size="small"
              v-model="stateValue"
              clearable
              placeholder="订单状态"
            >
              <el-option
                v-for="item in dms_order_state"
                :key="item.dictCode"
                :label="item.dictValue"
                :value="item.dictCode"
              ></el-option>
            </el-select>
            <el-date-picker
              class="ml20"
              size="small"
              v-model="dataTime"
              type="daterange"
              range-separator="~"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
          <div>
            <el-button @click="findorderList" size="small" type="primary"
              >查询</el-button
            >
            <el-button
              @click="closeOrder"
              size="small"
              type="primary"
              plain
              icon="el-icon-refresh-right"
            >
              重置
            </el-button>
          </div>
        </div>
        <el-tab-pane label="暂存订单" name="first">
          <el-button
            size="small"
            type="primary"
            @click="detailOrder"
            class="marginbottom10"
          >
            删除
          </el-button>
          <TableComponent
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
            :table_config="table_configY"
            :table_data="myorderdata1"
            @toOrderDetails="toOrderDetails"
            @multipleSelections="getSelectRow"
            @findclick="findclick"
          />
        </el-tab-pane>
        <el-tab-pane disabled :before-leave="false" label="|"></el-tab-pane>
        <el-tab-pane label="订单管理" name="second">
          <el-button
            size="small"
            type="primary"
            @click="confirmReceipt"
            class="marginbottom10"
          >
            批量收货
          </el-button>
          <el-button size="small" @click="open" class="marginbottom10">
            导出
          </el-button>
          <!--   -->
          <TableComponent
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
            :table_config="table_configN"
            :table_data="myorderdata2"
            @toOrderDetails="toOrderDetails"
            @drawerClicks="drawerClicks"
            @multipleSelections="getSelectRow"
            @findclick="findclick"
            @cancel="cancel"
          />
        </el-tab-pane>
        <template>
          <div class="pageschange">
            <el-pagination
              background
              layout="total,prev, pager, next"
              :total="total"
              :current-page.sync="pageNum"
              prev-text="上一页"
              next-text="下一页"
              @current-change="getDataMyOrder()"
            >
              <!-- @next-click="nextClick"
                           @prev-click="prevClick"
                           @current-change="currentClick" -->
            </el-pagination>
          </div>
        </template>
      </el-tabs>
    </el-card>
    <!-- <div v-if="visible"> -->
    <!-- <OrderDrawer
        :visible.sync="visible"
        :drawerdata="drawerdata"
        @handleClose="handleClose"
      /> -->
    <!-- </div> -->
    <ExportModal
      v-if="modalVisible"
      :visible="modalVisible"
      :params="modalParams"
      @onClose="close"
    ></ExportModal>
  </div>
</template>
<script>
/**
 * @description:  参数说明
 * @param {*}  Myorder 订单接口
 * @param {*}  mdmdictdata 数据字典，查询订单状态 state
 * @return {*}
 * @author: txp
 */
import {
  Myorder,
  mdmdictdata,
  mdmdictdatas,
  FindDetailsById,
  confirmReceipt,
  delTemporaryOrder,
  orderCancel,
} from '@/api/api'
import OrderDrawer from './Components/OrderDrawer'
import TableComponent from './Components/Tablecomponent'
// cal，用于去下单中先进行数据处理
import cal from '../../ShopSettle/js/cals'
import { Storage } from '@/utils/storage'
import { mapGetters } from 'vuex'
import ExportModal from '@/components/export_modal/export_modal.vue'
import { getUuid } from '@/utils'

export default {
  name: 'myorder',
  data() {
    return {
      orderCode: '',
      dataTime: [],
      activeName: 'first',
      visible: false, //判断下单弹框
      drawerdata: {}, //弹框内容
      myorderdata1: [],
      myorderdata2: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      stateValue: '', //订单状态
      loading: true, //loding默认加载
      dms_order_state: [], //获取订单列表状态
      dms_order_type: [], //订单状态数据字典
      dms_order_pick_type: [], //提货方式数据字典
      hd_order_receiving_status: [], //收货状态数据字典
      table_configY: {
        thead: [
          // { label: '订单编号', prop: 'orderCode' },
          // { label: "订单下单时间", prop: "createDateAll", width: 200 },
          { label: '订单状态', prop: 'stateName', width: 80 },
          { label: '订单类型', prop: 'typeName', width: 80 },
          { label: '是否含补货项商品', prop: 'ext10Name', width: 80 },
          { label: '提货方式', prop: 'pickTypeName', width: 80 },
          { label: '商品数量', prop: 'productNum', width: 80 },
          { label: '总重量（KG）', prop: 'weightOfKilogram', width: 120 },
          { label: '订单总金额（元）', prop: 'amount', width: 130 },
          { label: '政策优惠金额（元）', prop: 'promotionAmount', width: 140 },
          { label: '费用支付（元）', prop: 'repAmount', width: 120 },
          { label: '实际支付', prop: 'actualAmount', width: 120 },
        ],
        checkbox: false,
        myorderdata: [],
        goshopOrderBool: true,
        orderNumBool: false,
      },
      table_configN: {
        thead: [
          // {label:"订单编号",prop:"orderCode"},
          { label: 'SAP销售单号', prop: 'orderSalesCode', width: 120 },
          { label: '是否含补货项商品', prop: 'ext10Name', width: 80 },
          { label: '订单下单时间', prop: 'createDateAll', width: 160 },
          { label: '订单状态', prop: 'stateName', width: 80 },
          { label: '收货状态', prop: 'receivingStatusName', width: 80 },
          { label: '当前节点名称', prop: 'approveStatusName', width: 100 },
          // { label: '当前审批人', prop: 'stateName', width: 200 },
          { label: '提货方式', prop: 'pickTypeName', width: 80 },
          { label: '订单类型', prop: 'typeName', width: 80 },
          { label: '商品数量', prop: 'productNum', width: 80 },
          { label: '总重量（KG）', prop: 'weightOfKilogram', width: 120 },
          { label: '订单总金额（元）', prop: 'amount', width: 130 },
          { label: '政策优惠金额（元）', prop: 'promotionAmount', width: 140 },
          { label: '费用支付（元）', prop: 'repAmount', width: 120 },
          { label: '实际支付（元）', prop: 'actualAmount', width: 120 },

          // { label: '收货状态', prop: 'f', width: 200 }
        ],
        checkbox: true,
        orderdetBool: true,
        orderCodeBool: true, //订单编号
        stateBool: true, //订单状态
        orderNumBool: true, //订单编号
        goshopOrderBool: false,
      },
      orderSelectRow: [],
      modalVisible: false,
      modalParams: {},
    }
  },
  computed: {
    ...mapGetters({
      theme: 'theme',
    }),
  },
  components: {
    // OrderDrawer,
    TableComponent,
    ExportModal,
  },
  watch: {
    $route(val) {
      console.log(val)
      const type = val.query.type
      if (type) {
        this.activeName = type
        this.mdmdictdatas()
      }
    },
  },
  created() {
    const type = this.$route.query.type
    this.activeName = type || 'first'
    this.mdmdictdatas()
    console.log(11 + Storage.l.get('customerName'))
  },
  methods: {
    // 数据字典，获取订单状态
    async mdmdictdatas() {
      await mdmdictdatas([
        'dms_order_type',
        'dms_order_state',
        'dms_order_pick_type',
        'hd_order_receiving_status',
      ])
        .then((res) => {
          if (res.code == 200) {
            this.dms_order_state = res.result.dms_order_state
            this.dms_order_type = res.result.dms_order_type
            this.dms_order_pick_type = res.result.dms_order_pick_type
            this.hd_order_receiving_status =
              res.result.hd_order_receiving_status
            this.getDataMyOrder()
          }
        })
        .catch((error) => {
          this.$message.error(error)
        })
    },
    /**
     * @description: 获取订单列表 暂存订单 || 订单管理
     * @param {*}  orderCode
     * @return {*} startDate endDate  开始时间   结束时间
     * @return {*} state  订单状态
     * @return {*} temporaryFlag   "Y"暂存订单  || "N" 订单管理
     * @author: txp
     */

    getDataMyOrder() {
      this.loading = true
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        orderCode: this.orderCode,
        beginDate: this.dataTime[0] || '',
        endDate: this.dataTime[1] || '',
        state: this.stateValue,
        temporaryFlag: this.activeName == 'first' ? 'Y' : 'N',
      }
      Myorder(params).then((res) => {
        this.loading = false
        if (res.code == 200 && res.result.data) {
          const tableData = res.result.data.map((item) => {
            item.stateName = this.dms_order_state.find(
              (itemi) => itemi.dictCode == item.state
            )
              ? this.dms_order_state.find(
                  (itemi) => itemi.dictCode == item.state
                ).dictValue
              : ''
            item.typeName = this.dms_order_type.find(
              (itemi) => itemi.dictCode == item.type
            )
              ? this.dms_order_type.find((itemi) => itemi.dictCode == item.type)
                  .dictValue
              : ''
            item.pickTypeName = this.dms_order_pick_type.find(
              (itemi) => itemi.dictCode == item.pickType
            )
              ? this.dms_order_pick_type.find(
                  (itemi) => itemi.dictCode == item.pickType
                ).dictValue
              : ''
            item.receivingStatusName = this.hd_order_receiving_status.find(
              (itemi) => itemi.dictCode == item.receivingStatus
            )
              ? this.hd_order_receiving_status.find(
                  (itemi) => itemi.dictCode == item.receivingStatus
                ).dictValue
              : ''
            item.ext10Name = item.ext10 === 'Y' ? '是' : '否'
            return item
          })
          if (this.activeName == 'first') {
            this.myorderdata1 = tableData
            this.total = res.result.count
          } else {
            this.myorderdata2 = tableData
            this.total = res.result.count
          }
        }
      })
      // .catch(error => {
      //   this.$message.error(error);
      // });
    },
    /**
     * @description: 去下单，通过id，调用接口
     * @param {*} id 订单id
     * @return {*}
     * @author: txp
     */
    findclick(id) {
      this.$router.push({
        path: '/home/shopsesttle',
        query: {
          id,
        },
      })
      // const dataList = []
      // FindDetailsById(id).then(async res=>{
      //     if(res.code == 200 &&  res.result.groupItemVos){
      //       const dataList = await cal.handleTableData(
      //               res.result.groupItemVos
      //       );
      //       Storage.l.set('orderList',JSON.stringify({...res.result,dataList}))
      //       this.$router.push({
      //         path:'/home/shopsesttle',
      //         query:{
      //           id
      //         }
      //       })
      //     }
      // })
    },
    //  切换tab
    handleClick(tab) {
      this.activeName = tab.name
      this.loading = true
      ;(this.orderCode = ''),
        (this.dataTime = []),
        (this.pageNum = 1),
        (this.pageSize = 10),
        (this.stateValue = ''), //订单状态
        this.getDataMyOrder()
    },
    // // 隔行显示高亮
    // tableRowClassName({row, rowIndex}) {
    //   if (!(rowIndex%2 ==0)) {
    //     return 'success-row';
    //   }
    //   return '';
    // },
    /**
     * 查看订单详情 id
     */
    toOrderDetails(id) {
      this.$router.push({ path: '/home/shoporderlist', query: { id } })
    },
    // 查看
    drawerClicks(val) {
      this.visible = val.visible
      this.drawerdata = val.row
    },
    // 查询
    findorderList() {
      this.getDataMyOrder()
    },
    // 重置
    closeOrder() {
      ;(this.orderCode = ''),
        (this.dataTime = []),
        (this.pageNum = 1),
        (this.pageSize = 10),
        (this.stateValue = ''), //订单状态
        this.getDataMyOrder()
    },
    // 关闭弹框（头部的X）
    handleClose() {
      this.visible = false
    },
    // 获取订单选择数据
    getSelectRow(val) {
      this.orderSelectRow = val
    },
    //批量收货
    confirmReceipt() {
      const orderCodes = this.orderSelectRow.map((item) => item.orderCode)
      console.log(orderCodes)
      confirmReceipt({ orderCodes }).then(() => {
        this.$message.success('收货成功')
      })
    },
    //删除暂存订单
    detailOrder() {
      const ids = this.orderSelectRow.map((item) => item.id)
      delTemporaryOrder(ids).then(() => {
        this.$message.success('删除成功')
        this.getDataMyOrder()
      })
      console.log(ids)
    },
    // 作废订单
    cancel(id){
      orderCancel(id).then(()=>{
        this.$message.success('作废成功')
        this.getDataMyOrder()
      })
    },
    // // 分页处理
    // nextClick(nextPageNum) {
    //   this.loading = true;
    //   this.pageNum = nextPageNum;
    //   this.getDataMyOrder();
    // },
    // prevClick(prevPageNum) {
    //   this.loading = true;
    //   this.pageNum = prevPageNum;
    //   this.getDataMyOrder();
    // },
    // currentClick(currentPageNum) {
    //   this.loading = true;
    //   this.pageNum = currentPageNum;
    //   this.getDataMyOrder();
    // }

    // 打开弹框
    open() {
      this.modalParams = {
        sid: getUuid(32, 16),
        functionCode: 'dms_order_detailed_report',
        parentCode: 'CRM20210727000005147',
        requestUrl: '/order/hdOrderController/getOrderDetailList',
        import_terminal: 'front',
        orderCode: this.orderCode,
        beginDate: this.dataTime[0] || '',
        endDate: this.dataTime[1] || '',
        state: this.stateValue,
        temporaryFlag: 'N',
      }
      this.modalVisible = true
    },
    // 关闭弹框
    close() {
      this.modalVisible = false
      this.modalParams = {}
    },
  },
}
</script>
<style lang="scss" scoped>
.marginbottom10 {
  margin-bottom: 10px;
}
.myorder {
  height: 100%;
  /deep/ .el-card {
    height: 100%;
    .el-table .success-row {
      background: #fafafa;
    }
    .el-tabs__item {
      font-size: 18px;
      padding: 0px 10px;
      margin-bottom: 7px;
    }
    .el-tabs__active-bar {
      width: 73px !important;
    }
    .el-input {
      width: 200px;
    }
    .el-input__inner {
      border-radius: 2px;
      background: #f5f5f5;
    }
    .el-range-editor.el-input__inner {
      width: 236px;
    }
    // 选择框图标
    .el-icon-arrow-up:before {
      content: '\e790';
    }
    // 选择日期背景
    .el-range-input {
      background: #f5f5f5;
    }
  }
  //分页
  .pageschange {
    margin: 20px auto;
    text-align: center;
  }
}
</style>
